// Burned into the card image. Only Origami is relabeled; every other producer stays as stored.
export const POWER_ORIGINALS_LABEL = "Power Originals"

export function cardProviderLabel(producer: string): string {
  if (producer.trim().toLowerCase() === "origami") return POWER_ORIGINALS_LABEL
  return producer
}
